<template>
  <div class="overlay">
    <div class="line-section" :style="getLineStyle(1)"></div>
    <div class="line-section" :style="getLineStyle(2)"></div>
  </div>
</template>

<script>
export default {
  props: {
    boundingBox: {
      type: Object,
      required: true,
    },
    boundingBoxes: {
      type: Array,
      required: true,
    },
    color: {
      type: [Array, String],
      required: true,
    },
    zoomFactor: {
      type: Number,
      required: true,
    },
  },
  methods: {
    getLineStyle(part) {
      const color_30 = this.color + '33';
      return {
        marginTop: `${this.boundingBox.height}px`,
        position: `absolute`,
        width: `${this.boundingBox.width}px`,
        /* Height set to clip correctly basically background-size/2 */
        height: `${5 * this.zoomFactor}px`,
        background:
          part === 1
            ? `linear-gradient(45deg, ${color_30}, ${color_30} 45%, ${this.color} 45%, ${this.color} 55%, ${color_30} 55%)`
            : `linear-gradient(-45deg, ${color_30}, ${color_30} 45%,  ${this.color} 45%, ${this.color} 55%, ${color_30} 55%)`,
        backgroundSize: `${10 * this.zoomFactor}px ${10 * this.zoomFactor}px`,
      };
    },
  },
};
</script>
